import React from "react";
import CommonListSection from "../../component/common/CommonListSection";

const products = [
  {
    icon: "/images/plantIcon1.png",
    title: "Waste Solutions",
    desc: "We provide efficient and environmentally responsible waste treatment for organic materials from agriculture, industry, and municipalities. Our biogas systems reduce landfill dependency, lower emissions, and turn waste challenges into sustainable opportunities.",
  },
  {
    icon: "/images/plantIcon1.png",
    title: "Green Gas (Biogas & Biomethane)",
    desc: "We convert organic waste into clean, renewable green gas. Biogas can be used for electricity and heat generation or upgraded into biomethane for grid injection and transportation — providing a reliable alternative to fossil fuels.",
  },

  {
    icon: "/images/plantIcon1.png",
    title: "Renewable Energy Solutions",
    desc: "Our systems generate continuous, renewable energy that supports energy independence and long-term sustainability. Biogas offers stable power generation, complementing other renewable sources like solar and wind.",
  },
  {
    icon: "/images/plantIcon1.png",
    title: "Organic Fertilizer",
    desc: "The digestion process produces nutrient-rich digestate that can be safely reused as organic fertilizer. This natural by-product improves soil health, reduces reliance on chemical fertilizers, and supports sustainable farming practices.",
  },

  {
    icon: "/images/plantIcon1.png",
    title: "Circular Economy Impact",
    desc: "By integrating waste treatment, energy production, and fertilizer recovery, our solutions close the resource loop — creating value at every stage while minimizing environmental impact.",
  },
];
// const myMedia = [
//   "https://www.youtube.com/watch?v=7DLb8WRDoxA", // YouTube Link
// ];
const myMedia = [
  "/images/BioGasSolutions.png", // YouTube Link
];
const ProductRangeSection = () => {
  return (
    <CommonListSection
      subtitle="Our Range"
      title="Our Bio Gas Solutions"
      description="We offer an integrated range of sustainable solutions that transform organic waste into valuable resources. Our platform is designed to address waste management, energy generation, and agricultural sustainability — all in one circular system."
      items={products}
      media={myMedia}
      imageAlt="Carbon Footprint"
    />
  );
};

export default ProductRangeSection;
